module.exports = __webpack_public_path__ + "img/chest-endo-mesomorph-male.5229cade.svg";